<template>
    <div class="animated fadeIn">
        <filters :scope="filtersScope">
        </filters>
        <RefundsTabs></RefundsTabs>
        <StatisticTable :headColumns="headColumns"
                        :checkbox="true"
                        :footColumns="footColumns"
                        :rows="rows"
                        :checked="checked"
                        :title="`${$t('pages.ref_return_by_month')}`">
        </StatisticTable>
    </div>
</template>

<script>
  import Filters from '@/components/Filters.vue'
  import API from '@/api/API'
  import Storage from '@/api/Storage'
  import { map } from 'lodash'
  import Helper from '@/api/Helper'
  import TypeColor from '@/assets/TypeColor'
  import StatisticTable from '@/components/StatisticTable.vue'
  import RefundsTabs from './RefundsTabs.vue'

  export default {
    name: 'ReturnByMonth',
    components: {
      Filters,
      StatisticTable,
      RefundsTabs
    },
    data () {
      return {
        filtersScope: {
          dateFilter: true,
          offerFilter: true,
          courierFilter: true,
          byWmFilter: true,
          byWebmasterFilter: true
        },
        isLoading: false,
        checked: [],
        Storage: Storage,
        TypeColor: TypeColor,
        Helper: Helper,
        country: null,
        headColumns: [
          {label: this.$root.$t('statistic.return'), field: 'refunds_id'}
        ],
        rows: [],
        footColumns: {},
        EnMessage: [
          {id: 0, text: 'Без причины'},
          {id: 1, text: 'Дорого'},
          {id: 2, text: 'Передумал'},
          {id: 3, text: 'Доставка заняла слишком много времени'},
          {id: 4, text: 'Не понравилось качество посылки'},
          {id: 5, text: 'Курьер потребовал большую сумму'},
          {id: 6, text: 'Курьерская служба не позвонила и я не знал, что моя посылка доставлена'},
          {id: 7, text: 'Грубый курьер'},
          {id: 8, text: 'Я не мог забрать посылку в первый раз, но курьер не доставил её повторно'},
          {id: 9, text: 'Я нахожусь за городом'},
          {id: 10, text: 'Курьер не пришел'},
          {id: 11, text: 'Адрес/индекс неверный'},
          {id: 12, text: 'Клиент недоступен'},
          {id: 13, text: 'Проблемы с деньгами'},
          {id: 14, text: 'Клиент сменил адрес'},
          {id: 15, text: 'Не могу открыть посылку'},
          {id: 16, text: 'Не могу оплатить кредиткой'},
          {id: 17, text: 'Купил другой товар (в другом месте)'},
          {id: 18, text: 'Медицинские противопоказания'},
          {id: 19, text: 'Другое'},
          {id: 24, text: 'Недозвон в течении долгого времени'},
          {id: 25, text: 'Уже получил заказ'},
          {id: 26, text: 'Множественные смены даты доставки'}
        ]
      }
    },
    mounted () {
      this.calculateRows()
      this.$root.$on('filters_load_new_data', () => {
        this.calculateRows()
      })
    },
    methods: {
      calculateRows () {
        this.$root.$emit('data_loading')
        this.rows = []
        this.checked = []
        this.footColumns = {}
        this.headColumns = [
          {label: this.$root.$t('statistic.refundsId'), field: 'refunds_id'},
          {label: this.$root.$t('statistic.return'), field: 'refunds'}
        ]
        let language = Storage.language
        API.getReturnReasonStatisticByMonth(2).then(response => {
          let reasonsByMonth = []
          let footColumn = {
            reason_id: {
              value: ''
            },
            reason: {
              value: ''
            }
          }
          map(response.body, (year) => {
            map(year, (data, month) => {
              this.headColumns.push({
                label: this.$root.$t('month.' + month) + ' ' + Helper.percents(data.orders_count, data.reasons_count), field: 'month' + month, colspan: 2, bg: true
              })

              footColumn['month.' + month] = {
                value: data.reasons_count
              }
              footColumn['orders_month.' + month] = {
                // value: ' / ' + data.orders_count
                value: ''
              }
              map(data.reasons, (reason, reasonsId) => {
                if (reasonsByMonth[reasonsId] === undefined) {
                  reasonsByMonth[reasonsId] = {}
                }
                reasonsByMonth[reasonsId]['m' + month] = reason
                reasonsByMonth[reasonsId]['m' + month].reasons_count = data.reasons_count
              })
            })
          })
          reasonsByMonth.forEach((reasonData, reasonId) => {
            let row = {
              id: {value: reasonId},
              reason: {value: reasonId, style: {textAlign: 'left'}}
            }
            let checkd = {
              id: reasonId,
              total: {}
            }
            map(reasonData, (monthData, monthId) => {
              checkd.total['month.' + monthId.substring(1)] = {}
              checkd.total['month.' + monthId.substring(1)].count = monthData.count
              row.reason.value = language === 'ru' ? Helper.getCancelName(this.EnMessage, reasonId) : monthData.text
              row['month_count_' + monthId] = {}
              row['month_persent_' + monthId] = {}
              row['month_count_' + monthId] = {
                value: monthData.count
              }
              row['month_persent_' + monthId] = {
                value: Helper.percents(monthData.reasons_count, monthData.count),
                bgg: parseFloat(parseFloat(monthData.count) / parseFloat(monthData.reasons_count) * 100).toFixed(1)
              }
            })
            this.rows.push(row)
            this.checked.push(checkd)
          })
          this.footColumns = footColumn
          this.$root.$emit('data_loaded')
        }).catch(response => {
          this.$root.$emit('data_loaded')
          this.$notify({
            type: 'danger',
            title: this.$root.$t('verbs.error'),
            text: !response.body.message ? response.body : response.body.message,
            animationType: 'velocity'
          })
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// ReturnByMonth.vue?63e5c5d4